import { render, staticRenderFns } from "./modalVerDetalleSAV.vue?vue&type=template&id=399375d4&"
import script from "./modalVerDetalleSAV.vue?vue&type=script&lang=ts&"
export * from "./modalVerDetalleSAV.vue?vue&type=script&lang=ts&"
import style0 from "./modalVerDetalleSAV.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('399375d4', component.options)
    } else {
      api.reload('399375d4', component.options)
    }
    module.hot.accept("./modalVerDetalleSAV.vue?vue&type=template&id=399375d4&", function () {
      api.rerender('399375d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/solicitudAnulacionVenta/modalVerDetalleSAV.vue"
export default component.exports